'use client';

import { AlertTriangle } from 'lucide-react';

interface Props {
  acik: boolean;
  baslik: string;
  mesaj: string;
  onayMetni?: string;
  iptalMetni?: string;
  onOnayla: () => void;
  onIptal: () => void;
  tip?: 'tehlike' | 'uyari' | 'bilgi';
}

export default function UyariModal({
  acik,
  baslik,
  mesaj,
  onayMetni = 'Evet',
  iptalMetni = 'İptal',
  onOnayla,
  onIptal,
  tip = 'tehlike',
}: Props) {
  if (!acik) return null;

  const renkler = {
    tehlike: { bg: 'bg-red-100', ikon: 'text-red-500', buton: 'bg-red-500 hover:bg-red-600' },
    uyari: { bg: 'bg-yellow-100', ikon: 'text-yellow-500', buton: 'bg-yellow-500 hover:bg-yellow-600' },
    bilgi: { bg: 'bg-blue-100', ikon: 'text-blue-500', buton: 'bg-blue-500 hover:bg-blue-600' },
  };

  const r = renkler[tip];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0,0,0,0.4)', backdropFilter: 'blur(4px)' }}>
      <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-sm">
        <div className="flex items-center gap-3 mb-4">
          <div className={`w-12 h-12 ${r.bg} rounded-full flex items-center justify-center flex-shrink-0`}>
            <AlertTriangle className={`w-6 h-6 ${r.ikon}`} />
          </div>
          <div>
            <h3 className="font-bold text-gray-800">{baslik}</h3>
            <p className="text-sm text-gray-500">{mesaj}</p>
          </div>
        </div>
        <div className="flex gap-3">
          <button
            onClick={onIptal}
            className="flex-1 px-4 py-2.5 border border-gray-300 rounded-xl text-sm font-medium text-gray-700 hover:bg-gray-50 transition"
          >
            {iptalMetni}
          </button>
          <button
            onClick={onOnayla}
            className={`flex-1 px-4 py-2.5 ${r.buton} text-white rounded-xl text-sm font-medium transition`}
          >
            {onayMetni}
          </button>
        </div>
      </div>
    </div>
  );
}